<template>
    <div id="dashboard-page" class="mb-5">
      <b-row>
        <b-col md='8' class="mb-2 ml-0">
          <div class="d-flex">
            <h3 class="text-black mt-1 mb-3">{{$route.name}}</h3>
            <!-- <span class="ml-4 mb-4 mt-2 dashboard-border"><router-link to="/vehicle-dashboard">Vehicle Dashboard</router-link></span> -->
          </div>
        </b-col>
      </b-row>
      <b-card no-body class="card-dashboard">
      <b-row>
        <b-col md="3" v-if="!isLoading">
          <content-loader :width="300" :height="300" :speed="2" primaryColor="#EEEEEE">
            <rect x="0" y="5" rx="0" ry="0" width="392" height="235" />
          </content-loader>
        </b-col>
        <b-col md="3" v-else-if="$store.getters['account/accountData'].role !== 'Manager'">
          <a class="cardhover" :href="'#/reimbursement?limit=25&order=createdAt&page=1&start_date=' + this.createdDateTo + '&end_date=' + this.thismonthday + '&status=Approved'">
            <b-card no-body class="p-3 custom-card border-radius" style="background-color:#fff">
              <div class="text-center pt-2 pb-4">
                <p class="mb-2 pt-0" style="font-style:italic!important; font-size:15px!important; font-weight:bold!important;">This Month</p>
                <i class="icon-reimbursement-dashboard"></i>
                <p class="mb-2 pt-0 pb-1" style="font-size:16px!important;">
                  <strong>Total Approved Reimbursement</strong>
                </p>
                <p class="p-0 m-0" style="font-size:23px!important; font-weight:bold!important;">{{ dataAccount.account.currency }} {{ this.totalReimburse !== null ? formatPrice(this.totalReimburse) : '-' }}</p>
                <!-- <h3 class="p-0 m-0">{{ dataAccount.account.currency }} 23414141</h3> -->
              </div>
            </b-card>
          </a>
        </b-col>
        <b-col md="3" v-if="!isLoading">
          <content-loader :width="300" :height="300" :speed="2" primaryColor="#EEEEEE">
            <rect x="0" y="5" rx="0" ry="0" width="392" height="235" />
          </content-loader>
        </b-col>
        <b-col md="3" v-else>
          <a class="cardhover" :href="'#/overtime?limit=25&order=createdAt&page=1&start_date=' + this.createdDateTo + '&end_date=' + this.thismonthday + '&status=Approved'">
            <b-card no-body class="p-3 custom-card border-radius" style="background-color:#fff">
              <div class="text-center pt-2 pb-4">
                <p class="mb-2 pt-0" style="font-style:italic!important; font-size:15px!important; font-weight:bold!important;">This Month</p>
                <i class="icon-overtime-dashboard"></i>
                <p class="mb-2 pt-0 pb-1" style="font-size:16px!important;">
                  <strong>Total Approved Overtime</strong>
                </p>
                <p class="p-0 m-0" style="font-size:23px!important; font-weight:bold!important;">{{ this.totalHour !== null ? this.totalHour : '-' }} Hour(s)</p>
                <!--<h3 class="p-0 m-0">{{ this.totalHour }}</h3>-->
              </div>
            </b-card>
          </a>
        </b-col>
        <b-col md="6" v-if="!isLoading">
          <content-loader :width="600" :height="230" :speed="2" primaryColor="#EEEEEE">
            <rect x="0" y="5" rx="0" ry="0" width="600" height="230" />
          </content-loader>
        </b-col>
        <b-col md="6" v-else>
          <b-card-group>
            <b-card id="vehiclePadding" no-body class="p-3 custom-card border-radius" style="background-color:#fff">
              <b-row>
                <b-col md="6">
                  <router-link to="/vehicle">
                    <div class="text-center cardhover pt-4 pb-4">
                      <i class="icon-vehicle-dashboard"></i>
                      <p class="mb-2 pt-2" style="margin-bottom:20px!important;">
                        <strong>Total Vehicle</strong>
                      </p>
                      <p class="p-0 m-0" style="font-size:27px!important; margin-top:-9px!important; font-weight:bold!important;">{{totalVehicle}}</p>
                    </div>
                  </router-link>
                </b-col>
                <b-col md="6 border-left">
                  <a :href="'#/vehicle?status=1'">
                    <b-card class="text-left text-white" style="border-bottom: 0px solid #4CAF50!important;">
                      <p class="mb-0" style="color:#7B7B7B!important;">
                        <strong>Available</strong>
                      </p>
                      <p class="p-0 m-0 float-right" style="font-size:28px!important; color:#7B7B7B!important; font-weight:bold!important;">{{totalAvailable}}</p>
                    </b-card>
                  </a>
                  <hr id="vrhicle">
                  <a :href="'#/vehicle?status=0'">
                    <b-card class="text-left text-white">
                      <p class="mb-1" style="color:#7B7B7B!important;"><strong>On The Road</strong></p>
                      <p class="p-0 m-0 float-right" style="font-size:28px!important; color:#7B7B7B!important; font-weight:bold!important;">{{totalOnTheRoad}}</p>
                    </b-card>
                  </a>
                </b-col>
              </b-row>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="6" v-if="!isLoading">
          <content-loader :width="600" :height="400" :speed="2" primaryColor="#EEEEEE">
            <rect x="0" y="5" rx="0" ry="0" width="600" height="400" />
          </content-loader>
        </b-col>
        <b-col md="6 mb-1" v-else-if="$store.getters['account/accountData'].role !== 'Manager'">
        <div v-if="this.totalReimburse === 0">
          <b-card-group>
            <b-card class="p-3 custom-card border-radius" style="background-color:#fff">
              <a :href="'#/reimbursement?limit=25&order=createdAt&page=1&start_date=' + this.createdDateTo + '&end_date=' + this.thismonthday + '&status=Approved'">
                <div class="pb-1" id="border-reimburse">
                  <h5 id="barHeading">Reimbursement</h5>
                  <p id="barLabel">Approved Reimbursement</p>
                </div>
              </a>
              <p class="p-5 text-center no-data-label">
                <b-badge variant="secondary">There's no statistics data</b-badge>
              </p>
            </b-card>
          </b-card-group>
        </div>
        <div v-else>
          <b-card-group>
            <b-card no-body class="p-3 custom-card border-radius" style="background-color:#fff">
              <donut-chart v-on:afterLoad="donutLoad"></donut-chart>
            </b-card>
          </b-card-group>
        </div>
        </b-col>
        <b-col md="6" v-if="!isLoading">
          <content-loader :width="600" :height="400" :speed="2" primaryColor="#EEEEEE">
            <rect x="0" y="5" rx="0" ry="0" width="600" height="400" />
          </content-loader>
        </b-col>
        <b-col md="6 mb-1" v-else-if="$store.getters['account/accountData'].role !== 'Manager'">
          <b-card-group>
            <b-card no-body class="p-3 custom-card border-radius" style="background-color:#fff">
            <bar-chart></bar-chart>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <!--<b-col md="6">
        <bar-chart v-on:afterLoad="barLoad"></bar-chart>
        </b-col>-->
        <b-col md="12" v-if="!isLoading">
          <content-loader :width="600" :height="400" :speed="2" primaryColor="#EEEEEE">
            <rect x="0" y="5" rx="0" ry="0" width="600" height="400" />
          </content-loader>
        </b-col>
        <b-col md="12" v-else>
          <b-card-group>
            <b-card no-body class="p-3 custom-card border-radius" style="background-color:#fff">
              <a :href="'#/reimbursement?limit=25&order=createdAt&page=1&status=Requested'">
                <h5 class="mt-1 mb-3" style="color: #212529!important;">Requested Reimbursement</h5>
                <paginated-table ref="dataTable" :can-delete="false" :can-edit="false" :can-approve="false" :can-reject="false" :data-url="apiUrl.reimbursement" :data-key="dataKey" :data-columns="columns" :data-limit="10">
                </paginated-table>
              </a>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      </b-card>
      <br>
    </div>
</template>
<script>
  import Vue from 'vue'
  import PaginatedTable from '@/components/PaginatedTable'
  import DonutChart from '@/components/DonutChart'
  import LineChart from '@/components/LineChart'
  import { ContentLoader } from "vue-content-loader"
  import BarChart from '@/components/BarChart'

  export default {
    components: {
      PaginatedTable,
      DonutChart,
      ContentLoader,
      BarChart,
      LineChart
    },
    data: function() {
      var currentDate = new Date();
      var monthlymonth = new Date(currentDate)
      var twoDigitFirstMonth= ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
      var twoDigitFirstDate= "01";
      var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;

      var currentDate = new Date();
      var monthly = new Date(currentDate)
      var thismonth = ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
      var twoDigitFirstDates= "31";
      var thismonthday = currentDate.getFullYear() + "-" + thismonth + "-" + twoDigitFirstDates;

      return {
        isLoading: false,
        dataKey: 'reimbursement',
        thismonthday: thismonthday,
        createdDateTo: createdDateTo,
        dataAccount: this.$store.getters['account/accountData'],
        apiUrl: {
          // reimbursement: window.AppConfig.apiUrl + 'reimbursement?limit=5&status=Requested&start_date=' + createdDateTo + '&end_date=' + thismonthday,
          reimbursement: window.AppConfig.apiUrl + 'reimbursement?status=Requested',
          vehicle: window.AppConfig.apiUrl + 'vehicle',
          carAvailable: window.AppConfig.apiUrl + 'vehicle?status=1',
          carOnTheRoad: window.AppConfig.apiUrl + 'vehicle?status=0',
          dashboard: window.AppConfig.apiUrl + 'dashboard'
        },
        model: {
          noRequest: '',
          amount: '',
          requestedBy: {
              uuid: null,
              name: null
          },
          paidDate: '',
          paidTime: '',
          paidNote: '',
          startTime: '',
          endTime: '',
          status: '',
          note: '',
          createdAt: '',
          changedBy: '',
          reimburseType: null
        },
        columns: [
          {
              key: 'requestedBy',
              label: 'Employee',
              sortable: true
          },
          {
              key: 'createdAt',
              label: 'Date',
              sortable: true
          },
          {
              key: 'amount',
              label: 'Amount',
              sortable: true
          },
          {
              key: 'reimburseType',
              label: 'Type',
              sortable: true
          },
          // {
          //     key: 'note',
          //     label: 'Note'
          // },
          {
              key: 'status',
              label: 'Status'
          },
          {
              key: 'actionsReimburse',
              label: ''
          }
        ],
        reimbursementList: [],
        totalAmount: null,
        totalReimburse: null,
        totalVehicle: null,
        totalAvailable: null,
        totalOnTheRoad: null,
        totalHour: null
      }
    },
    mounted() {
      this.countAllVehicle()
      this.countCarAvailable()
      this.countCarOnTheRoad()
      this.getDashboardValue()
    },
    methods: {
      getDashboardValue() {
        this.$http.get(this.apiUrl.dashboard).then(response => {
          this.totalHour = response.data.totalOvertime
          this.totalReimburse = response.data.totalReimburse
        })
      },
      countAllVehicle () {
        this.isLoading = false
        this.$http.get(this.apiUrl.vehicle)
        .then(response => {
        this.isLoading = false;
        setTimeout(() => {
          this.isLoading = true;        
          this.totalVehicle = response.data.total_items
          }, 1000)
        })
      },
      countCarAvailable () {
        this.$http.get(this.apiUrl.carAvailable)
        .then(response => {
          this.totalAvailable = response.data.total_items
        })
      },
      countCarOnTheRoad () {
        this.$http.get(this.apiUrl.carOnTheRoad)
        .then(response => {
          this.totalOnTheRoad = response.data.total_items
        })
      },
      donutLoad (total) {
        this.totalAmount = total
      },
      lineLoad (hour) {
        this.totalHour = hour
      },
      getDateTime (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD HH:mm')
        } else {
          return '-'
        }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      getStatusColor (val) {
        switch (val) {
        case 'Requested':
          return 'info'
          // eslint-disable-next-line no-unreachable
          break
        case 'New':
          return 'info'
          // eslint-disable-next-line no-unreachable
          break
        case 'Approved':
          return 'success'
          // eslint-disable-next-line no-unreachable
          break
        case 'Completed':
          return 'success'
          // eslint-disable-next-line no-unreachable
          break
        case 'Rejected':
          return 'danger'
          // eslint-disable-next-line no-unreachable
          break
        case 'Paid':
          return 'primary'
          // eslint-disable-next-line no-unreachable
          break
        case false:
          return 'secondary'
          // eslint-disable-next-line no-unreachable
          break
        case true:
          return 'success'
          // eslint-disable-next-line no-unreachable
          break
        case '0':
          return 'danger'
          // eslint-disable-next-line no-unreachable
          break
        case '1':
          return 'success'
          // eslint-disable-next-line no-unreachable
          break
        }
      },
    }
  }
</script>
<style>
  .text-title-dashboard {
    font-size: 20px;
    font-weight: 700;
  }
  .icon-reimbursement-dashboard {
    display: inline-block;
    width: 100px;
    height: 80px !important;
    background-image: url('/img/general/reimburse.png');
    background-size: 70px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .icon-overtime-dashboard {
    display: inline-block;
    width: 100px;
    height: 80px !important;
    background-image: url('/img/general/overtime.png');
    background-size: 60px;
    margin-top: -1px!important;
    background-position: center;
    background-repeat: no-repeat;
  }
  .cardhover:hover {
    color: #7b7b7b !important;
  }
  .icon-vehicle-dashboard {
    display: inline-block;
    width: 100px;
    height: 80px !important;
    background-image: url('/img/general/car.png');
    background-size: 60px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .icon-available-dashboard {
    display: inline-block;
    width: 100px;
    height: 80px !important;
    background-image: url('/img/general/Car Availablemdpi.png');
    background-size: 60px;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>